import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useEspecificacao } from '../../contexts/EspecificacaoContext';
import Folha from './Folha';
import Quantidade from './Quantidade';
import SeletorAmbientes from './SeletorAmbientes';
import { aceitaDecimal, fmtQtd } from '../../utils/especificacao';

/**
 * "+ Especificar": escolhe o projeto (ou cria um), a quantidade e os ambientes.
 * O mesmo produto adicionado de novo SOMA na linha que já existe.
 */
export default function AdicionarEspecificacao() {
  const { apiUrl } = useAuth();
  const { produtoAdd: produto, fecharAdicionar, listaCatalogo: lista, ativa, criar, adicionar, avisar, abrirCesta } = useEspecificacao();
  const [especId, setEspecId] = useState(ativa?.id || lista[0]?.id || 'novo');
  const [novoNome, setNovoNome] = useState('');
  const [qtd, setQtd] = useState(1);
  const [ambientes, setAmbientes] = useState([]);
  const [obs, setObs] = useState('');
  const [comObs, setComObs] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const unid = produto.unid || 'UN';
  const foto = (produto.fotos || [])[0] || produto.foto;
  const jaTem = especId === ativa?.id ? (ativa?.itens || []).find(i => i.codpro === produto.codpro) : null;
  const criando = especId === 'novo';
  const podeSalvar = !salvando && qtd > 0 && (!criando || novoNome.trim().length >= 2);

  const confirmar = async () => {
    setSalvando(true); setErro('');
    try {
      let id = especId;
      if (criando) id = await criar(novoNome.trim());
      const r = await adicionar({ especId: id, codpro: produto.codpro, quantidade: qtd, ambientes, observacao: comObs ? obs : '' });
      const nome = criando ? novoNome.trim() : (lista.find(e => e.id === id)?.nome || 'sua especificação');
      avisar(r?.somado ? `Quantidade somada em “${nome}”` : `Adicionado em “${nome}”`, { rotulo: 'Ver especificação', fn: abrirCesta });
      fecharAdicionar();
    } catch (e) {
      setErro(e.response?.data?.error || 'Não foi possível adicionar. Tente de novo.');
    } finally { setSalvando(false); }
  };

  return (
    <Folha
      titulo="Especificar produto"
      onFechar={fecharAdicionar}
      largura={520}
      rodape={(
        <>
          <button type="button" className="esp-btn-sec" onClick={fecharAdicionar} disabled={salvando}>Cancelar</button>
          <button type="button" className="esp-btn" onClick={confirmar} disabled={!podeSalvar}>
            {salvando ? 'Adicionando…' : <><i className="bi bi-plus-lg" />{jaTem ? 'Somar à especificação' : 'Adicionar à especificação'}</>}
          </button>
        </>
      )}
    >
      <div className="esp-prod">
        <div className="esp-prod-foto">{foto ? <img src={`${apiUrl}${foto}`} alt="" /> : <i className="bi bi-box-seam" />}</div>
        <div className="esp-prod-info">
          <div className="esp-prod-nome">{produto.nome}</div>
          <div className="esp-prod-meta">{[produto.fornecedor, `Cód ${produto.codpro}`].filter(Boolean).join(' · ')}</div>
        </div>
      </div>

      {erro && <div className="esp-erro"><i className="bi bi-exclamation-circle" />{erro}</div>}

      <label className="esp-rotulo">Projeto</label>
      {lista.length > 0 && (
        <select className="esp-campo" value={especId} onChange={e => setEspecId(e.target.value === 'novo' ? 'novo' : Number(e.target.value))}>
          {lista.map(e => (
            <option key={e.id} value={e.id}>
              {e.nome}{e.cliente_nome ? ` — ${e.cliente_nome}` : ''} ({e.itens} {e.itens === 1 ? 'item' : 'itens'})
            </option>
          ))}
          <option value="novo">＋ Novo projeto…</option>
        </select>
      )}
      {criando && (
        <>
          <input className="esp-campo mt-2" value={novoNome} maxLength={120} autoFocus
            placeholder="Nome do projeto" onChange={e => setNovoNome(e.target.value)} />
          <div className="esp-dica">Uma especificação por cliente ou obra. O nome do cliente você coloca depois, ao finalizar.</div>
        </>
      )}

      <label className="esp-rotulo">Quantidade</label>
      <Quantidade valor={qtd} unidade={unid} onChange={setQtd} />
      {aceitaDecimal(unid) && unid.toUpperCase() === 'M2' && (
        <div className="esp-dica">Informe a <strong>área líquida</strong>. A margem de perda (recortes/quebra) a Centrão calcula na cotação.</div>
      )}
      {jaTem && (
        <div className="esp-dica info"><i className="bi bi-info-circle" />Esse projeto já tem {fmtQtd(jaTem.quantidade, jaTem.unidade)} desse produto — a quantidade vai ser somada.</div>
      )}

      <label className="esp-rotulo">Para quais ambientes? <span className="opc">opcional</span></label>
      <SeletorAmbientes valor={ambientes} onChange={setAmbientes} sugestoes={ativa?.sugestoesAmbiente || []} />

      {comObs ? (
        <>
          <label className="esp-rotulo">Observação</label>
          <textarea className="esp-campo" rows={2} maxLength={500} value={obs} autoFocus
            placeholder="Ex.: rejunte cinza platina, paginação 1/3" onChange={e => setObs(e.target.value)} />
        </>
      ) : (
        <button type="button" className="esp-link mt-3" onClick={() => setComObs(true)}><i className="bi bi-chat-left-text" />Adicionar observação</button>
      )}
    </Folha>
  );
}
